export default __webpack_public_path__ + "7531556c7132b548d02b081545215db0.svg";